import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledContainer = styled('div')(() => ({
  display: 'flex',
  gap: 6,
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledLine = styled('div')(() => ({
  display: 'flex',
  flex: 1,
  backgroundColor: COLORS.grey200,
  height: 1,
}));
